<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainForm">
	<div class="TextCenter">
		<h4>Bell Schedule Details:</h4>
	</div>

	<div class="Grid2Col TopMargin">
		<!--INSERT CUSTOM POPUP FIELDS-->
		<label>Name:</label>
		<input class="form-control" type="text" placeholder="" [(ngModel)]="BellScheduleDesc" />
	</div>
</div>

<div class="MainForm TopMargin">
	<div class="TextCenter">
		<h4>Periods:</h4>
	</div>

	<!--Select and edit periods-->
	<div class="TopMargin TableWidth">
		<caass-bell-schedule-periods [SchoolID]="SchoolID" (ListChanged)="onListChanged($event)"> </caass-bell-schedule-periods>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAddBellSchedule()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
